import { isTemplatePdf } from '@common/helpers/helpers';
import useDefaultTemplateLang from '@hooks/useDefaultTemplateLang/useDefaultTemplateLang';
import { useTranslation } from 'react-i18next';

export default (values) => {
  const { t } = useTranslation();
  const [defaultLanguage] = useDefaultTemplateLang();

  const errors = {};
  let isValid = true;

  if (!values?.name?.length) {
    errors.name = t('ValidationTemplateName');
    isValid = false;
  }

  if (!defaultLanguage) {
    errors.defaultLanguage = t('ValidationDefaultLanguage');
    isValid = false;
  }

  if (!values?.type) {
    errors.type = t('ValidationTemplateType');
    isValid = false;
  }

  if (!values?.source?.id) {
    errors.source = t('ValidationSourceTemplate');
    isValid = false;
  }

  if (isTemplatePdf(values?.type)) {
    if (!values?.pdfAdditionalFields?.format) {
      errors.format = t('ValidationFormat');
      isValid = false;
    }

    if (!values?.pdfAdditionalFields?.orientation) {
      errors.orientation = t('ValidationOrientation');
      isValid = false;
    }
  }

  return { isValid, errors };
};
